import { QueryClient } from "@tanstack/react-query";

// Shared QueryClient instance for the entire app
// This ensures consistent caching across all components
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});



